import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";

const BASE = `${u}/spaces`;

export const listSpaces     = () => apiFetch(BASE).then(r => r.ok ? r.json() : []);
export const createSpace    = (name, description) => apiFetch(BASE, { method: "POST", body: JSON.stringify({ name, description }) }).then(r => r.json());
export const joinSpace      = (inviteCode) => apiFetch(`${BASE}/join`, { method: "POST", body: JSON.stringify({ inviteCode }) }).then(r => r.json());
export const leaveSpace     = (id) => apiFetch(`${BASE}/${id}/leave`, { method: "DELETE" });
export const deleteSpace    = (id) => apiFetch(`${BASE}/${id}`, { method: "DELETE" });
export const listMembers    = (id) => apiFetch(`${BASE}/${id}/members`).then(r => r.ok ? r.json() : []);
export const listItems      = (id) => apiFetch(`${BASE}/${id}/items`).then(r => r.ok ? r.json() : []);
export const regenCode      = (id) => apiFetch(`${BASE}/${id}/regenerate-code`, { method: "POST" }).then(r => r.json());

export const getActivity    = (id) => apiFetch(`${BASE}/${id}/activity`).then(r => r.ok ? r.json() : []);
export const getComments    = (spaceId, itemId) => apiFetch(`${BASE}/${spaceId}/items/${itemId}/comments`).then(r => r.ok ? r.json() : []);
export const addComment     = (spaceId, itemId, content) => apiFetch(`${BASE}/${spaceId}/items/${itemId}/comments`, { method: "POST", body: JSON.stringify({ content }) }).then(r => r.json());
export const deleteComment  = (commentId) => apiFetch(`${BASE}/comments/${commentId}`, { method: "DELETE" });
